import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { selectors } from "reducers";
import { PureModal, TableButton } from "components/ui";
import { IoEdit } from "react-icons/lib/io";
import { put } from "utils/api";
import { useFetch } from "hooks";

const BulkUpdateFollowUps = ({ selectedRows, refreshData, complianceCoaches, sleepCoaches, user }) => {

  const isAdmin = user.role === "CompanyAdministrator" || 
                          user.role === "Administrator" || 
                          user.role === "ServiceAdmin" ||
                          user.role === "ServiceCoach";
  
  const [option, setOption] = useState(isAdmin ? "assign_coach" : "markAsWorked");
  const [selectedCoach, setSelectedCoach] = useState("");
  const [coachOptions, setCoachOptions] = useState([]);
  
  useEffect(() => {
    if (user?.compliance_coach === false && sleepCoaches.length > 0) {
      setCoachOptions(sleepCoaches);
    }
    if (user?.compliance_coach && complianceCoaches.length > 0) {
      setCoachOptions(complianceCoaches);
    }
  }, [complianceCoaches, sleepCoaches, user?.compliance_coach]);

  const assignCoachAPI = useFetch({
    apiFn: ({ sleep_coach, patient_ids }) =>
      put(`incomplete_order_tracking/assignCoach`, { sleep_coach, patient_ids })
  });

  const markAsAPI = useFetch({
    apiFn: payload => put(`incomplete_order_tracking/markAs`, payload)
  });

  return (
    <PureModal
      renderTrigger={({ openModal }) => (
        <TableButton
          disabled={selectedRows.length === 0}
          onClick={openModal}
          title={`Bulk update Follow-ups (${selectedRows.length} selected)`}
        >
          <IoEdit />
        </TableButton>
      )}
      renderContent={({ closeModal }) => (
        <div style={{ padding: 5 }}>
          <h3>Bulk update follow-ups - {selectedRows.length} Selected</h3>
          <select
            onChange={({ target }) => setOption(target.value)}
            value={option}
          >
            {isAdmin && <option value="assign_coach">Assign Coach</option>}
            <option value="markAsWorked">Mark As Worked</option>
            {isAdmin && <option value="markAsReset">Reset</option>}
          </select>
          {option === "assign_coach" && (
            <div>
              <label>Coach</label>
              <select
                value={selectedCoach}
                onChange={({ target }) => setSelectedCoach(target.value)}
              >
                <option />
                {coachOptions.map(x => (
                  <option value={x.value} key={x.value}>
                    {x.text}
                  </option>
                ))}
              </select>
            </div>
          )}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gridGap: 30
            }}
          >
            <button onClick={closeModal} className="secondary">
              Cancel
            </button>
            <button
              disabled={option === "assign_coach" && !selectedCoach}
              onClick={async () => {
                if (option === "assign_coach") {
                  await assignCoachAPI.fetchData({
                    sleep_coach: selectedCoach,
                    patient_ids: selectedRows.map(x => x.patient_id)
                  });
                } else {
                  await markAsAPI.fetchData({
                    mark_as: option,
                    patient_ids: selectedRows.map(x => x.patient_id)
                  });
                }
                refreshData();
                closeModal();
              }}
            >
              Submit
            </button>
          </div>
        </div>
      )}
    />
  );
};

export default connect(state => ({
  sleepCoaches: selectors.getFormOptionsSleepCoachWithUserFirst(state),
  complianceCoaches: selectors.getComplianceCoaches(state),
  user: selectors.getUser(state)
}))(BulkUpdateFollowUps);

BulkUpdateFollowUps.propTypes = {
  selectedRows: PropTypes.arrayOf(PropTypes.object),
  refreshData: PropTypes.func.isRequired,
  sleepCoaches: PropTypes.arrayOf(PropTypes.object).isRequired,
  complianceCoaches: PropTypes.arrayOf(PropTypes.object).isRequired,
  user: PropTypes.object.isRequired
};